import PropTypes from "prop-types";

const QuestionNavigator = ({
  totalQuestions,
  currentQuestion,
  answeredQuestions,
  onQuestionChange,
}) => {
  const getQuestionStatus = (index) => {
    const questionNumber = index + 1;

    if (currentQuestion === questionNumber) {
      return "bg-blue-600 text-white border-blue-600";
    }

    if (answeredQuestions.includes(questionNumber)) {
      return "bg-green-100 text-green-700 border-green-400";
    }

    return "bg-gray-100 text-gray-700 border-gray-300";
  };

  const handleQuestionChange = (index) => {
    if (onQuestionChange) {
      onQuestionChange(index);
    }
  };

  if (!totalQuestions || totalQuestions <= 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-gray-800">Questions</h3>

        <div className="flex gap-3 text-xs">
          <div className="flex items-center gap-1">
            <span className="w-3 h-3 rounded-full bg-blue-600" />
            Current
          </div>

          <div className="flex items-center gap-1">
            <span className="w-3 h-3 rounded-full bg-green-400" />
            Answered
          </div>

          <div className="flex items-center gap-1">
            <span className="w-3 h-3 rounded-full bg-gray-300" />
            Pending
          </div>
        </div>
      </div>

      <div className="grid grid-cols-5 sm:grid-cols-8 md:grid-cols-10 gap-2">
        {Array.from({ length: totalQuestions }, (_, index) => (
          <button
            key={index}
            type="button"
            aria-label={`Go to question ${index + 1}`}
            aria-current={currentQuestion === index + 1 ? "true" : undefined}
            onClick={() => handleQuestionChange(index)}
            className={`
                h-9
                w-9
                rounded-md
                border
                text-sm
                font-medium
                transition
                hover:scale-105

                ${getQuestionStatus(index)}
              `}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

QuestionNavigator.propTypes = {
  totalQuestions: PropTypes.number.isRequired,

  currentQuestion: PropTypes.number.isRequired,

  answeredQuestions: PropTypes.arrayOf(PropTypes.number),

  onQuestionChange: PropTypes.func,
};

QuestionNavigator.defaultProps = {
  answeredQuestions: [],

  onQuestionChange: undefined,
};

export default QuestionNavigator;
